// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportingDetailsGoalsEditPage_wrapper__x9Wgd"};